// @ts-ignore: SCSS module import handled by webpack/vite
import './App.scss';
import { BrowserRouter } from 'react-router-dom';

import HubRoutes from "./routes";

import AuthProvider from './context/authContext';
import ToastProvider from "./context/toastContext";
import HubToast from './components/toast';
import LoaderProvider from './context/loaderContext';
import HubLoader from './components/loader';
import FooterProvider from './context/footerContext';
import NewVersionProvider from './context/newversionContext';
import NewVersionModal from './components/modals/newVersionModal';
import CookieConsent from './components/cookieyes';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <LoaderProvider>
          <FooterProvider>
            <NewVersionProvider>
            <>
              <BrowserRouter>
                <HubRoutes />
              </BrowserRouter>

              <HubToast />
              <HubLoader />
              <NewVersionModal />
              <CookieConsent />
            </>
            </NewVersionProvider>
          </FooterProvider>
        </LoaderProvider>
      </ToastProvider>
    </AuthProvider>
  );
};

export default App;
